export default __webpack_public_path__ + "static/media/46.184f66af.png";